<script setup>
import {useForm} from "../form/useForm";
import {ref} from "vue"
import FormLocationSelect from "../location/form-location-select.vue";
import FormCreateInfo from "../form/form-create-info.vue";

const props = defineProps({
  value: [Object, Boolean]
})

const emits = defineEmits([
  'done',
])

const warehouse = ref(props.value instanceof Object ? props.value : null)

const {form, changed, save, state} = useForm(
    ['name', 'desc', 'fkputaway', 'fkshipping', 'fkcleaning', 'fkphoto', 'fkphotodone'],
    '/api/warehouse',
    warehouse,
    null,
    () => emits('done')
)

</script>

<template>
  <div>
    <modal-portal to="footer" v-if="can('warehouses.write')">
      <b-button variant="primary" size="sm" class="px-4" @click="save">{{ warehouse ? 'Update' : 'Create' }}</b-button>
    </modal-portal>
    <modal-row label="GLI" v-if="warehouse">
      {{ warehouse.gli }}
    </modal-row>
    <form-create-info :value="warehouse" v-if="!!warehouse" />

    <modal-row label="Name" :feedback="state.name">
      <b-input v-model="form.name" :state="state.name | state" :disabled="!can('warehouses.write')"/>
    </modal-row>
    <modal-row label="Description" :feedback="state.desc">
      <b-input v-model="form.desc" :state="state.desc | state" :disabled="!can('warehouses.write')"/>
    </modal-row>
    <template v-if="!!warehouse && can('locations.index')">
      <form-divider/>
      <modal-row label="Putaway Location">
        <form-location-select :filter="'warehouse=' + warehouse.id" v-model="form.fkputaway"
                              :state="state.fkputaway | state"/>
      </modal-row>
      <modal-row label="Shipping (Pick To) Location">
        <form-location-select :filter="'warehouse=' + warehouse.id" v-model="form.fkshipping"
                              :state="state.fkshipping | state"/>
      </modal-row>
      <modal-row label="WIP Clean Location">
        <form-location-select :filter="'warehouse=' + warehouse.id" v-model="form.fkcleaning"
                              :state="state.fkcleaning | state"/>
      </modal-row>
      <modal-row label="WIP Photo Location">
        <form-location-select :filter="'warehouse=' + warehouse.id" v-model="form.fkphoto" :state="state.fkphoto | state"/>
      </modal-row>
      <modal-row label="Photo Done Location">
        <form-location-select :filter="'warehouse=' + warehouse.id" v-model="form.fkphotodone"
                              :state="state.fkphotodone | state"/>
      </modal-row>
    </template>
  </div>
</template>

<style scoped>

</style>